// @flow

import * as React from "react";
import { Grid, Button, Icon } from "tabler-react";
import SiteWrapper from "../../SiteWrapper.react";
import Catalogo from "../../components/Catalogo";
import ModalLay from "../../components/ModalLay/ModalLay";
import { GPSForm } from "../../Catalogos";
import GPSTiveForm from "../../Catalogos/Gps/GPSTiveForm";

import Crud_Catalogos from "../../herramientas/Crud_Catalogos";
var currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
function getfuntion (metodo = "get", obj = [], id = "", catalogo = "", stateVar = "", hiddenModl = "") {
  Crud_Catalogos(catalogo, "perfiles", metodo, id, obj, "", stateVar, hiddenModl, []).then((returnVal) => {
    switch (metodo) {
      case "get":
      if (stateVar === "funcionalidades") {
        for( let item of returnVal){
          if(item.nombre == "GPS"){ return true; }
        }
        window.history.back();
        window.location.href = "403";
      }  break;
      default:
        break;
    }
  }).catch(err => { console.log("Error desconocido ...."+ err); })
}
function GPSPage() {
  getfuntion("get", "", "", "funcionalidades/Administracion/"+currentUser[0].perfil.id, "funcionalidades");
  return (
    <SiteWrapper>
      <Grid.Col sm={12} lg={12}>
        <div className="mb-2">
          <ModalLay
            tamanio="500px"
            title="Alta GPS Tive"
            name={
              <Button size="sm" color="success">
                <Icon name="plus" /> Alta GPS Tive
              </Button>
            }
            formulario={GPSTiveForm}
            datosForm={{}}
          />
        </div>
        <Catalogo Ctlogo="gps" tamanio="98%" FCtlogo={ GPSForm } catalogos={{ 0: "gpsHardware", 1: "gpsEstatus", 2:"privilegios", 3: "gps"}}/>
      </Grid.Col>
    </SiteWrapper>
  );
}
export default GPSPage;
